var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTardeplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 887.79 479.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #56118d;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ff9400;\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-6 {\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-3 {\n        fill: #ff6209;\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-4, .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-5 {\n        fill: #f43914;\n        filter: url(#drop-shadow-3);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#230068",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff6209",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f43914",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.07
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m814.46,413.9L73.32,478.74C32.83,482.29,0,452.33,0,411.84v-235.86C0,135.48,32.83,99.78,73.32,96.24L814.46,31.39c40.5-3.54,73.32,26.41,73.32,66.91v235.86c0,40.5-32.83,76.2-73.32,79.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m826.02,326.8L61.76,393.66C27.65,396.65,0,371.41,0,337.3v-121.94C0,181.25,27.65,151.18,61.76,148.19l764.26-66.86c34.11-2.98,61.76,22.25,61.76,56.36v121.94c0,34.11-27.65,64.18-61.76,67.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m826.02,240.29L61.76,307.15C27.65,310.14,0,284.9,0,250.79v-93.89C0,122.79,27.65,92.72,61.76,89.73L826.02,22.87c34.11-2.98,61.76,22.25,61.76,56.36v93.89c0,34.11-27.65,64.18-61.76,67.17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m822.79,154.06L65,220.36C29.1,223.5,0,196.95,0,161.05v-23.81c0-35.9,29.1-67.55,65-70.69L822.79.25c35.9-3.14,65,23.41,65,59.31v23.81c0,35.9-29.1,67.55-65,70.69Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m155.9,252.08c-1.96.17-3.05-1.04-2.84-3.02l16.58-119.02-38.39,3.36c-1.96.17-3.16-1.03-2.84-3.02l2.62-18.99c.22-1.98,1.74-3.42,3.71-3.6l105.35-9.22c1.96-.17,3.05,1.04,2.84,3.02l-2.62,18.99c-.22,1.98-1.74,3.42-3.71,3.6l-38.39,3.36-16.58,119.02c-.22,1.98-1.74,3.42-3.71,3.6l-22.03,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m251.86,206.38c0-39.37,27.92-75.51,72.96-79.46,14.29-1.25,30.32.73,38.93,7.72l-9.27,67.23c-1.31,8.51-1.74,14.44,7.63,11.55,2.73-.89,4.8,1,3.82,6.1-1.42,8.09-8.4,16.44-19.09,17.38-12.65,1.11-20.94-8.64-19.09-27.34l.87-8.91-2.51.22c-10.8,25.27-23.67,41.22-42.97,42.91-18.98,1.66-31.3-11.22-31.3-37.4Zm83-51.87c-3.27-2.33-9.38-2.78-15.05-2.28-25.41,2.22-41.22,23.56-41.22,45.81,0,16.03,8.18,20.88,16.69,20.13,21.81-1.91,35.99-42.96,39.59-63.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m503.46,196.8c2.07,1.45,1.96,3.43,1.2,5.35-5.13,13.65-17.34,23.77-32.28,25.07-17.23,1.51-30.65-9.86-26.5-34.54l6.65-40.61c-6.87,5.51-16.58,9.3-27.05,10.22-2.62.23-5.02.22-7.42.1l-4.58,23.96c-.44,2.11-1.53,3.19-3.49,3.36l-19.52,1.71c-2.18.19-3.38-.9-2.94-3.23l6.98-36.93c-3.49-4.49-5.34-9.89-5.34-15.78,0-12.32,8.29-23.74,20.07-24.77,8.18-.72,14.18,3.89,14.18,11.19,0,6-4.03,11.37-9.71,12.52,1.2,2.73,5.02,4.8,13.31,4.07,13.85-1.21,26.72-9.1,30.76-18.07.76-1.92,1.85-2.89,3.71-3.05l20.07-1.76c2.29-.2,3.27,1.13,2.95,3.34l-11.78,70.94c-1.2,7.08-.44,13.23,5.67,12.7,4.8-.42,8.18-4.31,11.56-10.83,1.09-2.17,2.84-2.43,4.8-1.07l8.73,6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m520.14,183.13c0-39.7,28.14-75.75,72.31-79.62,4.8-.42,9.71-.41,14.29-.05l5.78-40.97c.33-2.21,1.53-3.19,3.49-3.36l20.18-1.77c2.18-.19,3.38,1.01,3.05,3.22l-16.47,117.81c-1.2,8.5-1.64,14.43,7.74,11.54,2.73-.89,4.8,1,3.82,6.1-1.42,8.09-8.4,16.44-19.09,17.38-12.65,1.11-20.94-8.64-19.09-27.34l.87-8.91-2.51.22c-10.69,25.26-24.76,41.32-44.06,43.01-18.65,1.63-30.32-11.42-30.32-37.26Zm83.11-52.1c-3.27-2.33-9.27-2.79-15.38-2.25-25.08,2.19-41.01,23.44-41.01,45.9,0,15.81,7.74,20.81,16.03,20.08,21.81-1.91,36.86-43.03,40.35-63.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m758.76,181.56c1.31,1.74,1.53,4.23-.55,6.05-11.56,11.15-27.7,17.04-44.82,18.54-34.68,3.03-53.88-15.03-53.88-44.36,0-35.12,27.59-66.54,63.36-69.67,24.21-2.12,36.64,10.21,36.64,25.37,0,17.23-15.81,37.7-70.67,55.37,4.47,7.79,13.3,11.92,27.59,10.67,11.67-1.02,22.03-4.65,30.1-10.49,2.62-1.87,4.36-1.58,5.67.05l6.54,8.48Zm-73.07-28.4c35.88-12.63,48.53-20.61,48.53-29.22,0-5.24-4.58-9.52-14.18-8.68-15.38,1.35-32.5,15.39-34.35,37.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m270.3,258.02c34.25-3,49.19,9.77,49.19,34.96,0,39.59-22.79,62.96-63.26,66.5l-20.39,1.78-6,43.17c-.33,1.99-1.75,3.42-3.71,3.6l-21.92,1.92c-1.96.17-3.16-1.03-2.84-3.02l19.63-141.32c.33-1.99,1.75-3.42,3.71-3.6l45.59-3.99Zm-12.32,76c22.03-1.93,33.81-11.57,33.81-33.6,0-14.61-9.93-18.11-26.83-16.63l-18.54,1.62-6.98,50.23,18.54-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m437.27,373.2c.98,1.77.55,3.22-.65,4.53-5.89,6.4-21.05,16.56-41.55,18.36-21.92,1.92-45.04-7.07-40.46-44.34l-21.7,9.53c-2.07.95-3.38-1.01-3.05-3.22l2.4-17.66c.33-2.21,1.74-3.42,3.6-4.24l22.47-9.71,7.42-51.14c4.91-32.6,24.76-43.39,44.28-45.1,26.28-2.3,40.03,12.75,40.03,34.56,0,23.99-17.01,52.53-58.68,70.68l-8.18,3.55-1.53,10.17c-2.94,19.23,8.29,23.38,18.98,22.44s19.52-5.96,25.52-10.41c2.18-1.61,4.03-1.44,5.34.95l5.78,11.06Zm-44.61-96.65l-5.67,37.36c26.28-12.99,36.97-29.96,36.97-44.35,0-8.94-3.71-16.14-14.07-15.24-8.94.78-14.83,6.86-17.23,22.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m473.03,346.18l6.87-35.5c1.75-8.55,1.53-14.42-7.85-11.53-2.73.89-4.8-1-3.82-6.1,1.42-8.08,8.4-16.44,18.87-17.36,13.2-1.15,24.32,8.56,20.72,27.2l-6.43,33.5c-3.27,16.65,2.07,24.36,11.02,23.58,15.7-1.37,31.52-28.61,39.92-85.4.33-2.21,1.53-3.19,3.49-3.36l20.72-1.81c2.18-.19,3.38.79,3.05,3.22l-10.25,72.66c-1.2,8.61-1.75,14.44,7.63,11.55,2.84-.9,4.8,1,3.93,6.09-1.42,8.08-8.4,16.44-18.98,17.36-13.2,1.15-22.9-8.58-20.39-27.23l1.42-9.94-2.4.21c-9.16,23.92-22.9,41.59-41.77,43.24-17.89,1.56-31.3-12.09-25.74-40.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m621.56,371.03c-6.54-2.04-12-5.06-12-6.37,0-2.84,5.23-12.02,6.98-12.17,1.31-.11,11.34,6.2,20.94,5.37,15.49-1.35,22.03-14.58,22.03-25.05,0-12.87-8.29-19.99-19.19-26.89-8.29-5.16-14.61-9.19-22.03-14.65l-.65.49c.44,2.8.87,7.78.87,10.61,0,15.27-4.58,31.15-9.38,40.52-.65,1.15-1.09,1.62-1.74,1.68-2.18.19-10.69-3.43-10.69-5.39,0-.87,1.09-3.15,1.74-4.73,3.71-8.83,6.98-21.55,6.98-36.16,0-12-3.05-19.15-3.05-21.33,0-2.84,11.12-10.35,14.18-10.62,1.09-.1,1.74.28,2.84,1.72,6.32,6.86,18.54,15.39,31.84,23.39,14.83,8.74,27.26,18.77,27.26,37.53,0,11.12-5.67,21.87-12.22,27.68l.44.83c13.3-4.43,30.53-15.32,38.61-35.66.44-1.13.87-1.82,1.74-1.9,1.96-.17,10.47,3.23,10.47,4.97,0,.87-.44,2-.65,2.68-10.25,29.25-36.21,42.86-67.39,45.59-10.69.94-21.59-.07-27.92-2.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTardeplus);
export default __webpack_public_path__ + "static/media/tardeplus.8a3aff38201b5a4ce0f45af330cf13f8.svg";
export { ForwardRef as ReactComponent };